<div *ngIf="globalUtilityService.loader$ | async"
  class="overlay w-full h-full fixed flex justify-center items-center text-primary">
  <p-progressSpinner strokeWidth="2" animationDuration=".5s" />
</div>
<router-outlet></router-outlet>
<div *ngIf="(toastMessage$ | async)?.message" class="toast" [ngClass]="(toastMessage$ | async)?.type">
  {{ (toastMessage$ | async)?.message }}
</div>
<p-dialog p-dialog 
  [style]="{ width: '60rem' }" 
  [breakpoints]="{ '1199px': '100vw', '575px': '100vw' }"   
  [(visible)]="showLoginPopup"
  styleClass="transparent-dialog"
  >
  <app-login [minimal]="true" (loggedIn)="showLoginPopup=false"></app-login>
</p-dialog>
<!-- <app-modal *ngIf="showLoginPopup">
  <div class="relative">
    <button class="close-btn" (click)="this.showLoginPopup=!this.showLoginPopup">×</button>
  </div>
</app-modal> -->